import React, { Component } from "react";
import styles from "./cmsCompanyIntegrations.module.scss";
import { withIntegrations } from "../../../shared/containers/containerIntegrations";
import { DataGrid } from "@mui/x-data-grid";
import { withAuth } from "../../../shared/containers/containerAuth";
import { dateGridLocalTextOptions } from "../../../shared/services/dataGridLocalTextOptions";
import DeleteIcon from "@mui/icons-material/Delete";
import { MenuItem, Select, TextField } from "@mui/material";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";

class CmsCompanyIntegrations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      type: 0,
      login: null,
      password: null,
    };
  }

  componentDidMount() {
    const { companyId, onGetIntegraionTypes, onGetIntegraions } = this.props;

    onGetIntegraionTypes();
    onGetIntegraions({ companyId });
  }

  onDelete(id) {
    const { onDeleteIntegraions } = this.props;

    onDeleteIntegraions({ id });
  }

  getColumns() {
    return [
      {
        field: "title",
        headerName: "Ресурс",
        width: 250,
      },
      {
        field: "login",
        headerName: "Логин",
        width: 450,
      },
      {
        field: "deleteField",
        headerName: " ",
        width: 100,
        renderCell: (cellValues) => {
          return (
            <div
              onClick={(e) => {
                e.stopPropagation();
                this.onDelete(cellValues.id);
              }}
            >
              <DeleteIcon fontSize="small" />
            </div>
          );
        },
      },
    ].filter((x) => {
      if (x.field === "deleteField" && !this.props.data.permissions.includes(56004)) {
        return false;
      }

      return true;
    });
  }

  onHandleButtonClick() {
    const { companyId, onCreateIntegraions } = this.props;
    const { type, login, password } = this.state;

    onCreateIntegraions({ companyId, type, login, password });
    this.setState({ login: "", password: "" });
  }

  render() {
    const { type, login, password } = this.state;
    const { integrationTypes } = this.props;

    return (
      <div className={styles.cmsCompanyIntegrationsContainer}>
        <div className={styles.inputContainers}>
          <div className={styles.inputContainer}>
            <Select
              style={{ minWidth: "200px", height: "33px" }}
              onChange={(e) => {
                this.setState({ type: e.target.value });
              }}
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={type}
            >
              {integrationTypes.map((x, index) => {
                return (
                  <MenuItem key={index} value={x.id} className={styles.MuiButtonBase_resolve}>
                    {x.title}
                  </MenuItem>
                );
              })}
            </Select>
          </div>

          <div className={styles.inputContainer}>
            <TextField
              id="outlined-basic"
              label="Логин"
              variant="outlined"
              size="small"
              value={login}
              onChange={(e) => {
                this.setState({ login: e.target.value });
              }}
            />
          </div>

          <div className={styles.inputContainer}>
            <TextField
              id="outlined-basic"
              label="Пароль"
              variant="outlined"
              size="small"
              value={password}
              onChange={(e) => {
                this.setState({ password: e.target.value });
              }}
            />
          </div>

          <ButtonPrimary handleClick={this.onHandleButtonClick.bind(this)} title="Создать" />
        </div>

        <div className={styles.tableContainer}>
          <DataGrid
            rowHeight={30}
            ref={"DataGrid"}
            localeText={{
              ...dateGridLocalTextOptions,
              columnMenuUnsort: "По умолчанию",
              columnMenuSortAsc: "По возрастанию",
              columnMenuSortDesc: "По убыванию",
              footerRowSelected: (count) => `Cтрок выбранно: ${count}`,
              MuiTablePagination: {
                disabled: false,
                rowsPerPage: 100,
                rowsPerPageOptions: 100,
                labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} изs ${count === -1 ? `больше ${to}` : count}`,
              },
            }}
            rows={this.props.integrations}
            columns={this.getColumns()}
            disableRowSelectionOnClick
          />
        </div>
      </div>
    );
  }
}

export default withAuth(withIntegrations(React.memo(CmsCompanyIntegrations)));
